<div class="m-widget4__ext mf-t-editDocument">
    <ng-container *ngIf="definition">
        <div
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            class="btn m-btn m-btn--icon m-btn--icon-only m-btn--pill popup-to-show"
        >
            <i class="la la-ellipsis-v"></i>
        </div>
        <div class="dropdown-menu">
            <ng-container *ngFor="let item of definition">
                <div [hidden]="!item.isVisible" (click)="item.action()" class="dropdown-item dropDownItem">
                    {{ item.text }}
                </div>
            </ng-container>
        </div>
    </ng-container>
</div>
